import { Fragment } from 'react'

import { Divider, List } from '@material-ui/core'
import { useSelector } from 'react-redux'

import { selectInviters } from 'store/inviters'

import PendingInvite from './PendingInvite'

const PendingInvites = () => {
  const inviters = useSelector(selectInviters)

  return inviters.length === 0 ? null : (
    <>
      <List disablePadding>
        {inviters.map((invite) => {
          return (
            <Fragment key={invite.inviterId}>
              <Divider />
              <PendingInvite
                invite={invite}
                key={invite.inviterId}
              />
            </Fragment>
          )
        })}
      </List>
    </>
  )
}

export default PendingInvites
